import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'App/styled';
import { hexToRgb } from '@nykaa/ui-components/styles/utils';

import { REVIEW_QA_SECTION } from 'shared/constants/productPage';
import { State } from 'shared/store/types';
import { changeProductQuesAndRatingTab } from 'shared/store/product/action';
import Tabs from 'shared/components/Tabs';
import Reviews from 'layouts/Product/Reviews';
// import QuestionsSection from 'layouts/Product/QuestionAndAnswers';

const tabHeaders = {
  'Ratings & reviews': 0,
  // 'Product Q&A': 1,
};

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
`;

const Item = styled.div`
  display: block;
  color: ${({ theme }) => hexToRgb(theme.colors.textPrimary, 0.72)};
  line-height: 24px;
`;
const Header = styled.h2`
  ${({ theme }) => theme.typography.titleSmall};
  position: relative;
  color: ${({ theme }) => hexToRgb(theme.colors.textPrimary, 0.92)};
  margin-bottom: ${({ theme }) => theme.spacing.spacing120};
  margin-top: ${({ theme }) => theme.spacing.spacing80};
`;

const ReviewsAndQuestions = () => {
  const dispatch = useDispatch();
  const [activeTab, setTab] = useState(0);
  const tab = useSelector((state: State) => state.productPage.activeTab);

  if (tab !== activeTab) {
    setTab(tab);
  }

  const handleTab = (currentTab: number) => {
    setTab(currentTab);
    dispatch(changeProductQuesAndRatingTab(currentTab));
  };
  return (
    <>
      <Header>Product Details</Header>
      <Wrapper id={REVIEW_QA_SECTION}>
        <Tabs
          list={tabHeaders}
          activeTab={activeTab}
          onTabClick={handleTab}
        />
        <Item>
          {activeTab === 0 && <Reviews />}
          {/* {
            (activeTab === 1) && (
              <QuestionsSection/>
            )
          } */}
        </Item>
      </Wrapper>
    </>
  );
};

export default ReviewsAndQuestions;
